module.exports = __webpack_public_path__ + "static/img/android-app-download.ac4eb96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/android-app-download.png
// module id = 6D5C
// module chunks = 1